export const formStatusOptions = [
    {name:'New', value:'new'},
    {name:'In Progress', value:'inProgress'},
    {name:'Submitted', value:'submitted'},
    {name:'Cancelled', value:'cancelled'},
    {name:'Changes Submitted', value:'changesSubmitted'},
    {name:'Changes Approved', value:'changesApproved'},
    {name:'Changes Rejected', value:'changesRejected'},
    {name:'Complete', value:'complete'}
]

export const projectStatusOptions = [
    {name:'Unassigned', value:'unassigned'},
    {name:'In Progress', value:'inProgress'},
    {name:'In Review', value:'inReview'},
    {name:'Complete', value:'completed'},
    {name:'Cancelled', value:'cancelled'}
]